/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys, mutationKeys } from "./queryKeys";

export const useInvoiceRemovePackageInstance = (invoiceId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: mutationKeys.invoiceRemovePackageInstance(invoiceId),
    mutationFn: (data) =>
      fetcher({
        method: "DELETE",
        url: `/public/invoice/package/id/${invoiceId}/instance-id/${data.package_instance_id}`,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.invoice.detail(invoiceId) });
      queryClient.invalidateQueries({ queryKey: queryKeys.invoices.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.packages.byInvoice(invoiceId) });
    },
  });
};
